<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.81348 7.15723">
		<path d="M6.40674 7.15723a.75027.75027 0 0 1-.53027-.21973L.21973 1.28028A.7499221.7499221 0 0 1 1.28028.21973l5.12646 5.127 5.12642-5.127a.74992.74992 0 1 1 1.06054 1.06055L6.93702 6.9375a.75031.75031 0 0 1-.53028.21973Z"/>
	</svg>
</template>
